import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as ApexCharts from 'apexcharts';
import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';
// import * as d3 from 'd3';
declare const d3: any;

@Component({
	selector: 'app-opp-analysis',
	templateUrl: './opp-analysis.component.html',
	styleUrls: ['./opp-analysis.component.scss']
})
export class OppAnalysisComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() type: any;
	@Input() show_navigation: any;
	@Input() show_header: any;
	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
	) {}

	ngOnInit(): void {
		// this.type = "Institutional Customers to Deposit Clients Analysis";
		this.user_details = this.storageService.get("user_details");
		if (this.type == "Upside Opportunities Analysis") {
			this.description_sections = this.upside_opp_description_sections;
		} else if (this.type == "Retention Opportunities Analysis") {
			this.description_sections = this.retention_opp_description_sections;
		// } else if (this.type == "Institutional Customers to Investment Clients Analysis") {
		} else if (this.type == "Bank Customers to Investment Clients Analysis") {
			this.description_sections = this.leads_opp_description_sections;
		} else if (this.type == "New Prospects Analysis") {
			this.description_sections = this.non_customers_opp_description_sections;
		// } else if (this.type == "Reassignment - AI Advisor Assistant Analysis") {
		// } else if (this.type == "Reassignment - MAGI Analysis") {
		} else if (this.type == "MAGI Analysis") {
			this.description_sections = this.ai_advisor_assistant_description_sections;
		// } else if (this.type == "Reassignment - Associate Financial Advisor Analysis") {
		// } else if (this.type == "Reassignment - Junior Advisor Analysis") {
		} else if (this.type == "Junior Advisor Analysis") {
			this.description_sections = this.afa_description_sections;
		} else if (this.type == "Reassignment - AI Assistant Analysis") {
			this.description_sections = this.ai_advisor_assistant_description_sections;
		// } else if (this.type == "Institutional Customers to Deposit Clients Analysis") {
		} else if (this.type == "Bank Customers to Deposit Clients Analysis") {
			this.description_sections = this.deposit_opp_description_sections;
		} else if (this.type == "Non Customers Analysis") {
			this.description_sections = this.non_customers_opp_description_sections;
		} else if (this.type == "Bank Customers to Lending Clients Analysis") {
			this.description_sections = this.lending_opp_description_sections;
		} else if (this.type == "Bank Customers to Insurance Clients Analysis") {
			this.description_sections = this.insurance_opp_description_sections;
		} else if (this.type == "Lending Opportunities Analysis") {
			this.description_sections = this.lending_opp_description_sections;
		} else if (this.type == "Insurance Opportunities Analysis") {
			this.description_sections = this.insurance_opp_description_sections;
		} else if (this.type == "New Prospects Analysis - Investments") {
			this.description_sections = this.non_customers_opp_description_sections;
		} else if (this.type == "New Prospects Analysis - Deposits") {
			this.description_sections = this.non_customers_opp_description_sections;
		} else if (this.type == "New Prospects Analysis - Lending") {
			this.description_sections = this.lending_opp_description_sections;
		} else if (this.type == "New Prospects Analysis - Insurance") {
			this.description_sections = this.insurance_opp_description_sections;
		}


		this.getAnalysisData();

	}

	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		this.stateChanged.emit(data);
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
			c =
			k < 1
				? num.toFixed(0 + fixed)
				: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	analysis_data: any;
	analysis_data_loaded: boolean = false;
	getAnalysisData() {
		this.analysis_data_loaded = false;

		let role: any = "";
		if (this.user_details.role.role == 4) {
			role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			role = "AFA";
		} else if (this.user_details.role.role == 8) {
			role = "Relationship Manager";
		} else if (this.user_details.role.role == 11) {
			role = "Marketing Team";
		} else if (this.user_details.role.role == 13) {
			role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			role = "Insurance Agent";
		}

		let route: any = "";
		if (this.type == "Upside Opportunities Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=Opportunity" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Retention Opportunities Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=Retention" + "&opp_year=" + this.selected_opportunity_period;
		// } else if (this.type == "Institutional Customers to Investment Clients Analysis") {
		} else if (this.type == "Bank Customers to Investment Clients Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=New" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "New Prospects Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=New Prospect" + "&opp_year=" + this.selected_opportunity_period;
		// } else if (this.type == "Reassignment - AI Advisor Assistant Analysis") {
		// } else if (this.type == "Reassignment - MAGI Analysis") {
		} else if (this.type == "MAGI Analysis") {
			route = "";
		// } else if (this.type == "Reassignment - Associate Financial Advisor Analysis") {
		// } else if (this.type == "Reassignment - Junior Advisor Analysis") {
		} else if (this.type == "Junior Advisor Analysis") {
			route = "";
		} else if (this.type == "Reassignment - AI Assistant Analysis") {
			route = "";
		// } else if (this.type == "Institutional Customers to Deposit Clients Analysis") {
		} else if (this.type == "Bank Customers to Deposit Clients Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=members" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Non Customers Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=non_members" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Bank Customers to Lending Clients Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=lending" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Bank Customers to Insurance Clients Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=members" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Lending Opportunities Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=lending" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "Insurance Opportunities Analysis") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=insurance" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "New Prospects Analysis - Investments") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=New Prospect" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "New Prospects Analysis - Deposits") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=non_members" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "New Prospects Analysis - Lending") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=lending" + "&opp_year=" + this.selected_opportunity_period;
		} else if (this.type == "New Prospects Analysis - Insurance") {
			route = "/differentiatedanalysis/?role=" + role + "&opp_type=insurance" + "&opp_year=" + this.selected_opportunity_period;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.analysis_data = res;

				setTimeout(() => {
					this.createBreakdownChart();
					this.createRuleBasedBreakdownGraph();
					this.createAITrriggerBreakdownGraph();

					this.createCollapsibleTree();
				}, 200);

				this.analysis_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	createBreakdownChart() {
		let $this = this;
		const options = {
			colors: $this.analysis_data["donout_graph"]["colors"],
			series: $this.analysis_data["donout_graph"]["data"],
			chart: {
				type: 'donut',
				// events: {
				// 	mounted: function(chartContext, config) {
				// 		setTimeout(() => {
				// 			const svgNS = "http://www.w3.org/2000/svg";
				// 			const svgElement = chartContext.el.querySelector('.apexcharts-svg');
				// 			const rect = svgElement.getBoundingClientRect();

				// 			// Dynamically calculate the center based on the SVG dimensions
				// 			const centerX = rect.width / 2;
				// 			const centerY = rect.height / 2;

				// 			chartContext.w.config.series.forEach((value, i) => {
				// 				const angle = (i / chartContext.w.config.series.length) * 2 * Math.PI; // Simplified; for evenly spaced circles
				// 				const radius = Math.min(centerX, centerY) * 0.75; // 75% towards the edge of the SVG
				// 				const x = centerX + radius * Math.cos(angle);
				// 				const y = centerY + radius * Math.sin(angle);

				// 				// Create and append the circle
				// 				let circle = document.createElementNS(svgNS, "circle");
				// 				circle.setAttribute("cx", x.toString());
				// 				circle.setAttribute("cy", y.toString());
				// 				circle.setAttribute("r", "30"); // Circle radius
				// 				circle.setAttribute("fill", "white");
				// 				// circle.setAttribute("fill", $this.analysis_data["donout_graph"]["colors"][i]);
				// 				circle.setAttribute("stroke", "#D3D3D3");
				// 				// circle.setAttribute("stroke", "#FFFFFF");
				// 				circle.setAttribute("stroke-width", "1");
				// 				// circle.setAttribute("stroke-width", "2");
				// 				svgElement.appendChild(circle);

				// 				// Create and append the text, adjust as needed
				// 				let text = document.createElementNS(svgNS, "text");
				// 				text.setAttribute("x", x.toString());
				// 				text.setAttribute("y", (y + 5).toString()); // Slightly offset for text alignment
				// 				text.setAttribute("text-anchor", "middle");
				// 				text.setAttribute("alignment-baseline", "middle");
				// 				text.setAttribute("fill", "black");
				// 				text.textContent = $this.commonService.abbreviateNumber(value).toString();
				// 				svgElement.appendChild(text);
				// 			});
				// 		}, 100); // Delay to ensure chart is fully rendered
				// 	}
				// },
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 500,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			plotOptions: {
				pie: {
					// startAngle: 180,
					// endAngle: -180,
					donut: {
						size: '65%',
						labels: {
							show: true,
							total: {
								show: true,
								showAlways: true,
								label: 'Total',
								fontSize: '16px',
								fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
								fontWeight: 400,
								color: '#000000',
								formatter: function (w) {
									// Calculate the total value
									const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
									// Custom label to display
									return `${(total.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))}`;
								}
							}
						}
					}
				}
			},
			dataLabels: {
				enabled: true,
				style: {
					fontSize: '18px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
					fontWeight: 400,
				},
				formatter(val, opts) {
					const data = $this.commonService.abbreviateNumber(opts.w.globals.series[opts.seriesIndex])
					return [data]
				},
			},
			labels: $this.analysis_data["donout_graph"]["labels"],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};
		var chart = new ApexCharts(document.querySelector("#breakdown-graph"), options);
		chart.render();
	}

	createRuleBasedBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["rulebasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["rulebasedtree_graph"]["data"]
				}
		  	],
			plotOptions: {
				treemap: {
				dataLabels: {
					// Turn OFF autoscaling so your fontSize is respected
					format: 'truncate',
				}
				}
			},
			dataLabels: {
				enabled: true,
				style: {
					fontSize: '18px !important',
					fontWeight: '400 !important',
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 500,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap'
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Condition:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['condition'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#rule-based-breakdown-graph"), options);
		chart.render();
	}

	createAITrriggerBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["aibasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["aibasedtree_graph"]["data"]
				}
		  	],
			plotOptions: {
				treemap: {
				dataLabels: {
					// Turn OFF autoscaling so your fontSize is respected
					format: 'truncate',
				}
				}
			},
			dataLabels: {
				enabled: true,
				style: {
					fontSize: '18px !important',
					fontWeight: '400 !important',
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 500,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap'
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#ai-triggers-breakdown-graph"), options);
		chart.render();
	}

	@ViewChild('treeContainer', { static: false }) private treeContainer: ElementRef;
	createCollapsibleTree() {
		const treeData = this.analysis_data["tree_graph"];

		var containerWidth = (d3.select('#tree-container').node().getBoundingClientRect().width) - 20;

		var margin = { top: 20, right: 90, bottom: 30, left: 220 },
		// width = 960 - margin.left - margin.right,
		width = containerWidth - margin.left - margin.right,
		height = 1500;

		var svg = d3
			.select(this.treeContainer.nativeElement)
			.append("svg")
			.attr("width", width + margin.right + margin.left)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		var i = 0,
			duration = 750,
			root;


		var treemap = d3.tree().size([height, width]);



		root = d3.hierarchy(treeData, function(d) {
			return d.children;
		});

		root.x0 = height / 2;
		root.y0 = 0;
		root.children.forEach(collapse);

		// expandAll(root);

		// root.children.forEach(child => collapseToDepth(child, 2)); // Collapse all nodes deeper than 2 levels
		expandToDepth(root, 2);

  		update(root);

		function collapse(d) {
			if (d.children) {
				d._children = d.children;
				d._children.forEach(collapse);
				d.children = null;
			}
		}

		function collapseToDepth(d, depth) {
			if (d.children && d.depth >= depth) {
				d._children = d.children;
				d._children.forEach(child => collapseToDepth(child, depth));
				d.children = null;
			} else if (d.children) {
				d.children.forEach(child => collapseToDepth(child, depth));
			}
		}

		function expandToDepth(d, depth) {
			if (d._children && d.depth < depth) {
				d.children = d._children;
				d._children = null;
				d.children.forEach(child => expandToDepth(child, depth));
			} else if (d.children) {
				d.children.forEach(child => expandToDepth(child, depth));
			}
		}

		function expandAll(d) {
			if (d._children) {
				d.children = d._children;
				d._children = null;
			}
			if (d.children) {
				d.children.forEach(expandAll);
			}
		}

	function update(source) {
		// var treeData = treemap(root);
		// var nodes = treeData.descendants(),
		// links = treeData.descendants().slice(1);


		// nodes.forEach(function(d) {
		// 	d.y = d.depth * 180;
		// });

		// Compute the new tree layout.
		var treeData = treemap(root);
		var nodes = treeData.descendants(),
		links = treeData.descendants().slice(1);

		var node = svg.selectAll("g.node").data(nodes, function(d) {
			return d.id || (d.id = ++i);
		});
		var nodeEnter = node
			.enter()
			.append("g")
			.attr("class", "node")
			.attr("transform", function(d) {
				return "translate(" + source.y0 + "," + source.x0 + ")";
			})
			.on("click", click);
			nodeEnter
			.attr("class", "node")
			.attr("r", 1e-6)
			.style("fill", function(d) {
				return d.parent ? "rgb(39, 43, 77)" : "#fe6e9e";
			});
			// nodeEnter
			//   .append("rect")
			//   .attr("rx", function(d) {
			//     if (d.parent) return d.children || d._children ? 0 : 6;
			//     return 10;
			//   })
			//   .attr("ry", function(d) {
			//     if (d.parent) return d.children || d._children ? 0 : 6;
			//     return 10;
			//   })
			//   .attr("stroke-width", function(d) {
		//     return d.parent ? 1 : 0;
		//   })
		//   .attr("stroke", function(d) {
		//     return d.children || d._children
		//       ? "rgb(38, 222, 176)"
		//       : "rgb(38, 222, 176)";
		//   })
		//   .attr("stroke-dasharray", function(d) {
		//     return d.children || d._children ? "0" : "2.2";
		//   })
		//   .attr("stroke-opacity", function(d) {
		//     return d.children || d._children ? "1" : "0.6";
		//   })
		//   .attr("x", 0)
		//   .attr("y", -10)
		//   .attr("width", function(d) {
		//     return d.parent ? 40 : 20;
		//   })
		//   .attr("height", 20);

		// nodeEnter
		//   .append("text")
		//   .style("fill", function(d) {
		//     if (d.parent) {
		//       return d.children || d._children ? "#000000" : "rgb(0, 0, 0)";
		//     }
		//     return "rgb(0, 0, 0)";
		//   })
		//   .attr("dy", ".35em")
		//   .attr("x", function(d) {
		//     return d.parent ? 20 : 10;
		//   })
		//   .attr("text-anchor", function(d) {
		//     return "middle";
		//   })
		//   .text(function(d) {
		//     return d.data.name + "("+ d.data.value + ")";
		//   });

		nodeEnter.append("circle")
				// .attr("r", 5)
				.attr("r", (d: any) => d.children || d._children ? 5 : 4)
				.attr("fill", (d: any) => d._children ? "#555" : "#999")
				.attr("stroke-width", 10);

				nodeEnter.append("text")
					.attr("dy", "0.35em") // Centers the text vertically relative to the node circle.
					// .attr("x", (d: any) => d.depth === 0 ? -10 : -10)
					.attr("x", (d: any) => d.children || d._children ? -10 : 10)
					// .attr("x", (d: any) => d.depth === 0 ? -10 : -5) // Positions root node text to the left, others to the right.
					// .attr("y", (d: any) => d.depth === 0 ? 0 : -15) // Positions root node text to the left, others to the right.
					// .attr("text-anchor", (d: any) => d.depth === 0 ? "end" : "start") // Aligns root text to the end, others to start.
					// .attr("text-anchor", "end") // Aligns root text to the end, others to start.
					.attr("text-anchor", (d: any) => d.children || d._children ? "end" : "start")
					// .style("font-size", "14px")
					.style("font-size", (d: any) => d.children || d._children ? "14px" : "11px")
					.style("fill", "#000000")
					.text((d: any) => d.data.name + "(" + (d.data.value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))  + ")");

		var nodeUpdate = nodeEnter.merge(node);

		nodeUpdate
		.transition()
		.duration(duration)
		.attr("transform", function(d) {
			return "translate(" + d.y + "," + d.x + ")";
		});
		var nodeExit = node
		.exit()
		.transition()
		.duration(duration)
		.attr("transform", function(d) {
			return "translate(" + source.y + "," + source.x + ")";
		})
		.remove();
		nodeExit.select("rect").style("opacity", 1e-6);
		nodeExit.select("rect").attr("stroke-opacity", 1e-6);
		nodeExit.select("text").style("fill-opacity", 1e-6);
		var link = svg.selectAll("path.link").data(links, function(d) {
		return d.id;
		});

		var linkEnter = link
		.enter()
		.insert("path", "g")
		.attr("class", "link")
		.attr("d", function(d) {
			var o = { x: source.x0, y: source.y0 };
			return diagonal(o, o);
		});

		linkEnter.merge(link)
			.transition()
			.duration(duration)
			.attr("d", function(d) {
				return diagonal(d, d.parent);
			})
			.style("stroke-width", "3px");

		var linkUpdate = linkEnter.merge(link);
		linkUpdate
		.transition()
		.duration(duration)
		.attr("d", function(d) {
			return diagonal(d, d.parent);
		});
		var linkExit = link
		.exit()
		.transition()
		.duration(duration)
		.attr("d", function(d) {
			var o = { x: source.x, y: source.y };
			return diagonal(o, o);
		})
		.remove();
		nodes.forEach(function(d) {
		d.x0 = d.x;
		d.y0 = d.y;
		});
		function diagonal(s, d) {
			let path = `M ${s.y} ${s.x}
				C ${(s.y + d.y) / 2} ${s.x},
					${(s.y + d.y) / 2} ${d.x},
					${d.y} ${d.x}`;

			return path;
		}



		function click(d) {
			if (d.children) {
				d._children = d.children;
				d.children = null;
			} else {
				d.children = d._children;
				d._children = null;
			}
			update(d);
		}
		}
	}


	createCollapsibleTree11() {
		const treeData = this.analysis_data["tree_graph"];

		var containerWidth = d3.select('#tree-container').node().getBoundingClientRect().width;

		var margin = { top: 20, right: 90, bottom: 30, left: 200 },
		// width = 960 - margin.left - margin.right,
		width = containerWidth - margin.left - margin.right,
		height = 900;

		var svg = d3
			.select(this.treeContainer.nativeElement)
			.append("svg")
			.attr("width", width + margin.right + margin.left)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		var i = 0,
			duration = 750,
			root;


		// var treemap = d3.tree().size([height, width]);



		// // Increase vertical space between nodes
		// var verticalSpacing = 20; // Adjust this value to increase vertical spacing
		// var horizontalSpacing = 200; // Example horizontal spacing
		// treemap.nodeSize([verticalSpacing, horizontalSpacing]);



		root = d3.hierarchy(treeData, function(d) {
			return d.children;
		});


		var treemap = d3.tree().size([height, width]);

		// Now adjust the SVG height based on the tree layout
		const minY = d3.min(root.descendants(), d => d.x);
		const maxY = d3.max(root.descendants(), d => d.x);
		const totalTreeHeight = maxY - minY + margin.top + margin.bottom;

		svg.attr('height', totalTreeHeight); // Adjust the height of the SVG
		d3.select('svg').attr('viewBox', `0 0 ${width + margin.left + margin.right} ${totalTreeHeight}`);

		// Increase vertical space between nodes
		var verticalSpacing = 20; // Adjust this value to increase vertical spacing
		var horizontalSpacing = 200; // Example horizontal spacing
		treemap.nodeSize([verticalSpacing, horizontalSpacing]);

		root.x0 = height / 2;
		root.y0 = 0;
		root.children.forEach(collapse);



		// const maxDepth = d3.max(root.descendants(), d => d.depth);
		// const svgHeight = (maxDepth + 1) * verticalSpacing + margin.top + margin.bottom;
		// d3.select('svg').attr('height', svgHeight);

		// d3.select('svg').attr('viewBox', [0, 0, width + margin.left + margin.right, svgHeight]);


		// treemap.nodeSize([verticalSpacing, width / (maxDepth + 1)]);

		expandAll(root);
  		update(root);

		const zoom = d3.zoom()
		  .scaleExtent([0.5, 5]) // Example scale range
		  .on('zoom', (event) => {
			  svg.attr('transform', event.transform);
		  });

	  d3.select('svg').call(zoom);

		function collapse(d) {
			if (d.children) {
				d._children = d.children;
				d._children.forEach(collapse);
				d.children = null;
			}
		}

		function expandAll(d) {
			if (d._children) {
				d.children = d._children;
				d._children = null;
			}
			if (d.children) {
				d.children.forEach(expandAll);
			}
		}

	function update(source) {
		// var treeData = treemap(root);
		// var nodes = treeData.descendants(),
		// links = treeData.descendants().slice(1);


		// nodes.forEach(function(d) {
		// 	d.y = d.depth * 180;
		// });

		// Compute the new tree layout.
		var treeData = treemap(root);
		var nodes = treeData.descendants(),
		links = treeData.descendants().slice(1);

		// Increase the depth factor here to increase vertical space
		// var depthFactor = 200; // Original depth factor, increase this value to give more space
		// nodes.forEach(function(d) {
		// 	d.y = d.depth * depthFactor; // Adjust this multiplier to increase vertical spacing
		// });

		var node = svg.selectAll("g.node").data(nodes, function(d) {
			return d.id || (d.id = ++i);
		});
		var nodeEnter = node
			.enter()
			.append("g")
			.attr("class", "node")
			.attr("transform", function(d) {
				return "translate(" + source.y0 + "," + source.x0 + ")";
			})
			.on("click", click);
			nodeEnter
			.attr("class", "node")
			.attr("r", 1e-6)
			.style("fill", function(d) {
				return d.parent ? "rgb(39, 43, 77)" : "#fe6e9e";
			});
			// nodeEnter
			//   .append("rect")
			//   .attr("rx", function(d) {
			//     if (d.parent) return d.children || d._children ? 0 : 6;
			//     return 10;
			//   })
			//   .attr("ry", function(d) {
			//     if (d.parent) return d.children || d._children ? 0 : 6;
			//     return 10;
			//   })
			//   .attr("stroke-width", function(d) {
		//     return d.parent ? 1 : 0;
		//   })
		//   .attr("stroke", function(d) {
		//     return d.children || d._children
		//       ? "rgb(38, 222, 176)"
		//       : "rgb(38, 222, 176)";
		//   })
		//   .attr("stroke-dasharray", function(d) {
		//     return d.children || d._children ? "0" : "2.2";
		//   })
		//   .attr("stroke-opacity", function(d) {
		//     return d.children || d._children ? "1" : "0.6";
		//   })
		//   .attr("x", 0)
		//   .attr("y", -10)
		//   .attr("width", function(d) {
		//     return d.parent ? 40 : 20;
		//   })
		//   .attr("height", 20);

		// nodeEnter
		//   .append("text")
		//   .style("fill", function(d) {
		//     if (d.parent) {
		//       return d.children || d._children ? "#000000" : "rgb(0, 0, 0)";
		//     }
		//     return "rgb(0, 0, 0)";
		//   })
		//   .attr("dy", ".35em")
		//   .attr("x", function(d) {
		//     return d.parent ? 20 : 10;
		//   })
		//   .attr("text-anchor", function(d) {
		//     return "middle";
		//   })
		//   .text(function(d) {
		//     return d.data.name + "("+ d.data.value + ")";
		//   });

		nodeEnter.append("circle")
				.attr("r", 5)
				.attr("fill", (d: any) => d._children ? "#555" : "#999")
				.attr("stroke-width", 10);

				nodeEnter.append("text")
					.attr("dy", "0.35em") // Centers the text vertically relative to the node circle.
					.attr("x", (d: any) => d.depth === 0 ? -10 : -10)
					// .attr("x", (d: any) => d.depth === 0 ? -10 : -5) // Positions root node text to the left, others to the right.
					// .attr("y", (d: any) => d.depth === 0 ? 0 : -15) // Positions root node text to the left, others to the right.
					// .attr("text-anchor", (d: any) => d.depth === 0 ? "end" : "start") // Aligns root text to the end, others to start.
					.attr("text-anchor", "end") // Aligns root text to the end, others to start.
					.style("font-size", "14px")
					.style("fill", "#000000")
					.text((d: any) => d.data.name + "(" +d.data.value  + ")");

		var nodeUpdate = nodeEnter.merge(node);

		nodeUpdate
		.transition()
		.duration(duration)
		.attr("transform", function(d) {
			return "translate(" + d.y + "," + d.x + ")";
		});
		var nodeExit = node
		.exit()
		.transition()
		.duration(duration)
		.attr("transform", function(d) {
			return "translate(" + source.y + "," + source.x + ")";
		})
		.remove();
		nodeExit.select("rect").style("opacity", 1e-6);
		nodeExit.select("rect").attr("stroke-opacity", 1e-6);
		nodeExit.select("text").style("fill-opacity", 1e-6);
		var link = svg.selectAll("path.link").data(links, function(d) {
		return d.id;
		});

		var linkEnter = link
		.enter()
		.insert("path", "g")
		.attr("class", "link")
		.attr("d", function(d) {
			var o = { x: source.x0, y: source.y0 };
			return diagonal(o, o);
		});

		linkEnter.merge(link)
			.transition()
			.duration(duration)
			.attr("d", function(d) {
				return diagonal(d, d.parent);
			})
			.style("stroke-width", "3px");

		var linkUpdate = linkEnter.merge(link);
		linkUpdate
		.transition()
		.duration(duration)
		.attr("d", function(d) {
			return diagonal(d, d.parent);
		});
		var linkExit = link
		.exit()
		.transition()
		.duration(duration)
		.attr("d", function(d) {
			var o = { x: source.x, y: source.y };
			return diagonal(o, o);
		})
		.remove();
		nodes.forEach(function(d) {
		d.x0 = d.x;
		d.y0 = d.y;
		});
		function diagonal(s, d) {
			let path = `M ${s.y} ${s.x}
				C ${(s.y + d.y) / 2} ${s.x},
					${(s.y + d.y) / 2} ${d.x},
					${d.y} ${d.x}`;

			return path;
		}



		function click(d) {
			if (d.children) {
				d._children = d.children;
				d.children = null;
			} else {
				d.children = d._children;
				d._children = null;
			}
			update(d);
		}
		}
	}

	createCollapsibleTree111() {
		const treeData = this.analysis_data["tree_graph"];

		var containerWidth = d3.select('#tree-container').node().getBoundingClientRect().width;


		// Set initial dimensions and margins
		var margin = { top: 20, right: 90, bottom: 30, left: 200 },
			width = containerWidth - margin.left - margin.right,
			height = 700 - margin.top - margin.bottom;

		// Create SVG container
		var svg = d3.select(this.treeContainer.nativeElement)
			.append("svg")
			.attr("width", width + margin.right + margin.left)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		var i = 0, duration = 750, root;

		// Create the tree layout
		var treemap = d3.tree().size([height, width]);

		// Assigns parent, children, height, depth
		root = d3.hierarchy(treeData, function(d) { return d.children; });
		root.x0 = height / 2;
		root.y0 = 0;

		// Function to collapse the node and all it's children
		function collapse(d) {
			if (d.children) {
				d._children = d.children;
				d._children.forEach(collapse);
				d.children = null;
			}
		}

		// Initially collapse all children
		root.children.forEach(collapse);

		// Function to expand all nodes
		function expandAll(d) {
			if (d._children) {
				d.children = d._children;
				d._children = null;
			}
			if (d.children) d.children.forEach(expandAll);
		}

		// Optionally expand all nodes from the start
		expandAll(root);

		// Define diagonal projection for use in the node links
		function diagonal(s, d) {
			const path = `M ${s.y} ${s.x}
						  C ${(s.y + d.y) / 2} ${s.x},
							${(s.y + d.y) / 2} ${d.x},
							${d.y} ${d.x}`;
			return path;
		}

		// Update function for updating the tree layout
		function update(source) {
			// Assigns the x and y position for the nodes
			var treeData = treemap(root);

			// Compute the new tree layout.
			var nodes = treeData.descendants(),
				links = treeData.links();

			// Normalize for fixed-depth by increasing vertical space
			var depthFactor = 200; // Increased depth factor to create more space between nodes
			nodes.forEach(function(d) { d.y = d.depth * depthFactor; });

			// ****************** Nodes section ***************************
			// Update the nodes...
			var node = svg.selectAll('g.node')
				.data(nodes, function(d) {return d.id || (d.id = ++i); });

			// Enter any new nodes at the parent's previous position.
			var nodeEnter = node.enter().append('g')
				.attr('class', 'node')
				.attr('transform', function(d) {
					return 'translate(' + source.y0 + ',' + source.x0 + ')';
				})
				.on('click', click);

			// Add Circle for the nodes
			nodeEnter.append('circle')
				.attr('class', 'node')
				.attr('r', 5)
				.style('fill', function(d) {
					return d._children ? '#555' : '#999';
				});

			// Add labels for the nodes
			nodeEnter.append('text')
				.attr('dy', '.35em')
				.attr('x', function(d) {
					return d.children || d._children ? -13 : 13;
				})
				.attr('text-anchor', function(d) {
					return d.children || d._children ? 'end' : 'start';
				})
				.text(function(d) { return d.data.name; });

			// UPDATE
			var nodeUpdate = nodeEnter.merge(node);

			// Transition to the proper position for the node
			nodeUpdate.transition()
				.duration(duration)
				.attr('transform', function(d) {
					return 'translate(' + d.y + ',' + d.x + ')';
				});

			// Update the node attributes and style
			nodeUpdate.select('circle.node')
				.attr('r', 5)
				.style('fill', function(d) {return d._children ? '#555' : '#999';})
				.attr('cursor', 'pointer');

			// ****************** Links section ***************************
			// Update the links...
			var link = svg.selectAll('path.link')
				.data(links, function(d) { return d.target.id; });

			// Enter any new links at the parent's previous position.
			var linkEnter = link.enter().insert('path', 'g')
				.attr('class', 'link')
				.attr('d', function(d){
					var o = {x: source.x0, y: source.y0}
					return diagonal(o, o)
				});

			// UPDATE
			var linkUpdate = linkEnter.merge(link);

			// Transition back to the parent element position
			linkUpdate.transition()
				.duration(duration)
				.attr('d', function(d){ return diagonal(d.source, d.target) });

			// Remove any exiting links
			var linkExit = link.exit().transition()
				.duration(duration)
				.attr('d', function(d) {
					var o = {x: source.x, y: source.y}
					return diagonal(o, o)
				})
				.remove();

			// Store the old positions for transition.
			nodes.forEach(function(d){
				d.x0 = d.x;
				d.y0 = d.y;
			});

			// Toggle children on click.
			function click(event, d) {
				if (d.children) {
					d._children = d.children;
					d.children = null;
				} else {
					d.children = d._children;
					d._children = null;
				}
				update(d);
			}
		}

		// Call update for the first time to draw the initial tree
		update(root);
	}


	description_sections: any = [];

	upside_opp_description_sections: any = [
		{
			name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
			sub_sections: [
				{
					name: "Overview",
					value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
				},
				{
					name: "Trigger Event Business Rules",
					value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
				},
				{
					name: "AI-Driven Opportunities",
					value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
				},
				{
					name: "Navigation",
					value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
				},
				{
					name: "Ranking System",
					value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
				},
				{
					name: "Purpose",
					value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
				},
			]
		},
	];

	retention_opp_description_sections: any = [
		{
			name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
			sub_sections: [
				{
					name: "Section Purpose",
					value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
				},
				{
					name: "Trigger Event Business Rules Component",
					value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
				},
				{
					name: "AI-Driven Risk Detection",
					value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
				},
				{
					name: "Detailed Risk Analysis",
					value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
				},
				{
					name: "Prioritization of Risks",
					value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
				},
				{
					name: "Strategic Benefits",
					value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
				},
			]
		},
	];

	leads_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Investment Clients' Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the 'Bank Customers to Investment Clients' Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Investment Clients' section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Investment Clients' section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	prospects_opp_description_sections: any = [
		{
			name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				{
					name: "Purpose of the 'New Prospects' Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					value: "The 'New Prospects' section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	ai_advisor_assistant_description_sections: any = [
		{
			name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
			sub_sections: [
				{
					name: "Section Purpose",
					// value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
				},
				{
					name: "Benefits of Reassignment",
					// value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
					value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
				},
				{
					// name: "AI Advisor Assistant Capabilities",
					name: "MAGI Capabilities",
					// value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
					value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
					sub_sections: [
						{
						name: "Best Client Interaction Strategy",
						value: "Tailored communication tactics to engage clients effectively."
						},
						{
							name: "Upside Opportunities Identification",
							value: "Recognition of potential areas for financial growth within the client's portfolio."
						},
						{
							name: "Retention Risk Analysis",
							value: "Detection of signals that may indicate a client is at risk of ending their services."
						},
					]
				},
				{
					name: "Training and Performance",
					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
				},
				{
					name: "Automation and Efficiency",
					// value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
					value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
				},
			]
		},
	];

	afa_description_sections: any = [
		{
			name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
			sub_sections: [
				{
					name: "Section Purpose",
					// value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
				},
				{
					name: "Benefits of Reassignment",
					// value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
					value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
				},
				{
					// name: "AI Advisor Assistant Capabilities",
					name: "MAGI Capabilities",
					// value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
					value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
					sub_sections: [
						{
						name: "Best Client Interaction Strategy",
						value: "Tailored communication tactics to engage clients effectively."
						},
						{
							name: "Upside Opportunities Identification",
							value: "Recognition of potential areas for financial growth within the client's portfolio."
						},
						{
							name: "Retention Risk Analysis",
							value: "Detection of signals that may indicate a client is at risk of ending their services."
						},
					]
				},
				{
					name: "Training and Performance",
					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
				},
				{
					name: "Automation and Efficiency",
					// value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
					value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
				},
			]
		},
	];

	deposit_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Deposit Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	non_customers_opp_description_sections: any = [
		{
			name: "The Non Customers section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				{
					name: "Purpose of the Non Customers Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Non Customers into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					value: "The 'Non Customers section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

  lending_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Lending Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

  insurance_opp_description_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Insurance Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

	rule_based_tooltip_section: any = [
		{
			name: "Rules-Based Triggers have been developed in collaboration with financial advisors, wealth management experts, and industry thought leaders, drawing on the collective experience of these professionals over the past 30 to 40 years."
		},
		{
			name: "This knowledge encompasses how financial advisors and institutions have historically identified new opportunities, cross-selling potentials, and clients who may be at risk of departing. These triggers are adaptable and can be customized to align with the specific internal regulations of any organization."
		}
	];

	ai_based_tooltip_section: any = [
		{
			name: "AI triggers have been pinpointed through the analysis of three specific scenarios as outlined below:",
			sub_sections: [
				{
					name: "",
					value: "Shifts in customer habits, as well as market and geographical conditions, have been monitored over the last 3 to 5 years. This analysis has consistently revealed certain opportunities or risks."
				},
				{
					name: "",
					value: "The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences.The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences."
				},
				{
					name: "",
					value: "A series of potential opportunities and risks have been identified by AI. Although they are not frequently occurring at present, they are forecasted to happen in the future."
				},
			]
		},
	];
}

